module.exports = __webpack_public_path__ + "img/payanyone.69e66985.png";